import React from 'react';

const NoData = (props) => (
  <span style={{ fontStyle: 'italic', color: '#888' }} {...props} />
);

export default NoData;
